export default __webpack_public_path__ + "static/media/kitchen3-afterJ-480w.bfe5bf43.avif";